package com.milta.feature.profile.domain.usecase

import com.milta.feature.auth.presentation.OTP_LENGTH
import com.milta.feature.profile.domain.repository.ProfileRepository

class ConfirmPhoneChangeUseCase(private val repository: ProfileRepository) {
    suspend operator fun invoke(code: String): Result<Unit> {
        require(code.length == OTP_LENGTH) { "otp_invalid_length" }
        return repository.confirmPhoneChange(code)
    }
}
